import { render, staticRenderFns } from "./VideoCompo.vue?vue&type=template&id=465868ef"
import script from "./VideoCompo.vue?vue&type=script&lang=js"
export * from "./VideoCompo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports